import {deserialize} from '../serializes/searchesList';
import {processSearchDesign, applySearch, getAllSearchesFilters} from '../services/searchesService';
import {formsStore} from '../../Form/stores/FormsStore';
import {serializeSearchesDlg, serializeQueryFilters} from '../serializes/searchesList';
import {prepareExecuteSearch} from '../../../_shared/GWTBridge/invoke/netForm';

export function executeHotKeySearch(index) {
    const store = formsStore.currentForm.searches;
    if (index === '0') {
        executeSearch(store, store.defaultIdx);
    } else {
        executeSearch(store, index);
    }
}

export function executeSearch(store, index) {
    if (index !== null) {
        prepareExecuteSearch(index);
        applySearch(index)
            .then(response => {
                store.setNewSearch(null);
                const search = store.searchesList[index];
                updateFilters(search, store, response);
                store.setFormSelected(search);
            })
            .catch(err => console.log(err));
    }
}

export function selectFormSearch(search) {
    const {store, index} = search;
    executeSearch(store, index);
}

function updateFilters(search, store, data) {
    if (search.filters.size === 0) {
        const activeSearch = serializeQueryFilters(store.form, data);
        activeSearch && activeSearch.filters && search.setFilters(activeSearch.filters);
    }
}

export function selectGeneratorSearch(search) {
    const {store} = search;
    store.deleteNewSearch();
    store.setGeneratorSelected(search);
}

export function setTempSearch(item) {
    const {store} = item;
    store.deleteNewSearch();
    store.setGeneratorSelected(item);
}

export function setActiveSearch(item) {
    const {store} = item;
    store.setGeneratorSelected(item);
}

export function setDefaultSearch(item) {
    const {store, index} = item;
    store.toggleDefault(index);
    saveSearches(store.savedSearchesList);
}

export async function reorderSearches(store, list, destinationIdx) {
    store.setReorderedList(list, destinationIdx);
    const data = await saveSearches(store.savedSearchesList);
    updateSearchListServerIndex(store, data);
}

function updateSearchListServerIndex(store, data) {
    const queryDesign = data.Form[0].QueryDesigns[0].QueryDesign;
    store.savedSearchesList.forEach((filter, index) => {
        filter.serverIdx = queryDesign[index].num;
    });
}

export function deleteSearch(item) {
    const {store} = item;
    store.deleteSearch(item);
    saveSearches(store.savedSearchesList);
}

export async function saveSearches(list) {
    const outputJson = deserialize(list);
    return await processSearchDesign(outputJson);
}

export function getAllFilters(generatorSelected = null) {
    const store = formsStore.currentForm.searches;
    return getAllSearchesFilters().then(response => {
        updateAllFilters(store, response);
        generatorSelected && store.setGeneratorSelected(generatorSelected);
    });
}

function updateAllFilters(store, data) {
    const {saved, previous} = serializeSearchesDlg(store.form, data);
    if (saved && saved.length > 0) {
        store.searchesList.forEach(search => {
            if (search) {
                const queryFilter = saved[search.serverIdx];
                if (queryFilter) {
                    search.setIgnoreCase(queryFilter.ignoreCase);
                    search.setFilters(queryFilter.filters);
                }
            }
        });
    }
    store.setPreviousList(previous);
}

export function changeSearchTitle(search) {
    if (search.name !== search.newName) {
        saveSearches(search.store.savedSearchesList);
    }
}

export function validateSearchTitle(selectedSearch) {
    const {newName} = selectedSearch;
    if (newName && newName.length > 0) {
        const sameNameArr = selectedSearch.store.savedSearchesList.filter(
            search => search.name === newName
        );
        if (sameNameArr.length === 0) {
            return true;
        }
    }
    return false;
}

export function createNewSearch() {
    const store = formsStore.currentForm.searches;
    store.addNewGeneratorSearch();
}

export function resetSearches(store) {
    store.deleteNewSearch();
    store.setGeneratorSelected(store.formSelected);
}

export function changeIgnoreCase(search) {
    search.setIgnoreCase(!search.ignoreCase);
}

export function validateAndSetName(search) {
    const isValid = validateSearchTitle(search);
    if (isValid) {
        search.setName(search.newName);
    } else {
        search.resetNewName();
    }
}
